module.exports = __webpack_public_path__ + "img/pause_mod.2ed21f38.svg";